import React from "react";
import HeaderTransprent from "../../components/HeaderTransprent";
import Footer from "../../components/Footer";
import Faq from "../../ui/Faq";
import Faq2 from "../../ui/Faq2";


const PrivacyandPolicy = () => {

  return (
    <>
      <HeaderTransprent />
      <section className="bg-[#2196F3]/10 bg-cover bg-no-repeat bg-right w-full h-auto" style={{ backgroundImage: `url('/img/home/sub-header-bg.webp')`, }}>
        <div className="w-full h-full">
          <div className="flex flex-col mx-auto px-4 xl:px-0 py-20 w-full 2xl:w-9/12 xl:w-11/12 h-full">
            <div data-aos="fade-up" className="flex flex-col justify-center items-center space-y-2 text-[#3D405B]">
              <h2 className="font-bold text-5xl xl:text-6xl capitalize leading-[3rem] xl:leading-[3.5rem] textcolor">FAQs</h2>
            </div>
          </div>
        </div>  
      </section>

      <section className="space-y-6 mx-auto px-4 xl:px-0 py-16 2xl:w-9/12 xl:w-11/12">

        <Faq />
        <Faq2 />

      </section>

      <Footer />
    </>
  );
};

export default PrivacyandPolicy;
